import { createSlice } from "@reduxjs/toolkit";
import { contactUsFaqAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const contactUsFaqSlice = createSlice({
  name: "contactUsFaq",
  initialState: data,
  reducers: {
    contactUsFaqSlice(state) {
      state.isLoading = true;
    },
    contactUsFaqSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    contactUsFaqSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    contactUsFaqSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const contactUsFaqHandler = () => async (dispatch: any) => {
  try {
    dispatch(contactUsFaqAction.contactUsFaqSlice());
    const response: any = await contactUsFaqAPI();
    dispatch(contactUsFaqAction.contactUsFaqSliceSuccess(response));
  } catch (e: any) {
    dispatch(contactUsFaqAction.contactUsFaqSliceFailure(e?.response?.data?.message));
    dispatch(contactUsFaqAction.contactUsFaqSliceReset());
  }
};
export default contactUsFaqSlice.reducer;
export const contactUsFaqAction = contactUsFaqSlice.actions;
